import SearchOverlay from '../snippets/search-overlay';
const Header = {
  headerRoot: null,
  headerContainer: null,
  cartCTA: null,
  mobileMenuOpenCTA: null,
  menuButtons: null,

  initiliaseElement() {
    this.headerContainer = document.querySelector('.js-header-container');
    this.cartCTA = this.headerContainer?.querySelector('.js-header-cart-cta');
    this.mobileMenuOpenCTA = this.headerContainer?.querySelector(
      '.js-mobile-menu-cta',
    );
    this.menuButtons = this.headerContainer?.querySelectorAll(
      'button.group[aria-expanded]',
    );
  },

  initializeEvents() {
    this.initiliaseElement();
    if (this.cartCTA != null) {
      this.cartCTA.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCart();
      });
    }
    // Add hover event listeners for mega menu
    if (this.menuButtons) {
      this.menuButtons.forEach((button) => {
        button.addEventListener('mouseenter', () => {
          document.body.style.overflow = 'hidden';
        });

        button.addEventListener('mouseleave', () => {
          document.body.style.overflow = 'auto';
        });

        button.addEventListener('focus', () => {
          document.body.style.overflow = 'hidden';
        });

        button.addEventListener('blur', () => {
          document.body.style.overflow = 'auto';
        });
      });
    }
  },

  openCart() {
    const drawerEvent = new CustomEvent('open-drawer', {
      detail: { drawerName: 'cart-drawer' },
    });
    window.dispatchEvent(drawerEvent);
  },
};

export default Header;
